import React, { forwardRef, Ref } from 'react';
import { IconBaseProps, SizeTypes } from '../interface';
import classNames from 'classnames';
import { usePrefixCls } from '../../_utils';

const DirectionBottomIcon = forwardRef((props: IconBaseProps, ref: Ref<SVGSVGElement>) => {
  const prefixCls = usePrefixCls('icon');
  const { size, color, className, style: customStyle, ...restProps } = props;

  let isFontSize = false;
  let isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = SizeTypes.findIndex(item => item === size) !== -1;
  }

  const classes = classNames(
    prefixCls,
    prefixCls + '--direction-bottom',
    { ['size-' + size]: isSize },
    className,
  );

  const style = {
    color,
    fontSize: isFontSize ? size : undefined,
    ...customStyle,
  };

  return (
    <svg
      ref={ref}
      className={classes}
      style={style}
      {...restProps}
      height="16px"
      width="16px"
      version="1.1"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="arrowdown"
    >
      <g fill="none">
        <path d="M8 11.3333L12 4.99998L4 4.99998L8 11.3333Z" fill="currentColor" fillOpacity="0.9" />
      </g>
    </svg>
  );
});

export default DirectionBottomIcon;
